import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable import/dynamic-import-chunkname */
import { useEffect, useRef, useState } from 'react';
import { triggerI18nFailedToLoad, useCreateFireAnalyticsFromTrigger } from '../../../analytics';
export var supportedLocales = ['cs-CZ', 'da-DK', 'de-DE', 'es-ES', 'et-EE', 'fi-FI', 'fr-FR', 'hu-HU', 'it-IT', 'ja-JP', 'ko-KR', 'nb-NB', 'nl-NL', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'sk-SK', 'sv-SE', 'tr-TR', 'th-TH', 'uk-UK', 'vi-VI', 'zh-TW', 'zh-HK', 'zh-ZH', 'zh-CN'
// react-intl-next does not support these locales
// 'zh-Hant',
// 'zh-Hans',
];
export var getCodesFromLocale = function getCodesFromLocale(locale) {
  var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
  if (!match) {
    throw Error('Unable to get language and country from invalid Locale');
  }
  var _match = _slicedToArray(match, 3),
    language = _match[1],
    country = _match[2];
  return {
    language: language.toLowerCase(),
    // when country code is missed, let it empty and we will use language/locale to find language file
    country: country ? country.toUpperCase() : ''
  };
};
export function fetchLanguageFile(locale) {
  switch (locale) {
    case 'cs-CZ':
    case 'cs':
      return import('../../../../../i18n/cs');
    case 'da-DK':
    case 'da':
      return import('../../../../../i18n/da');
    case 'de-DE':
    case 'de':
      return import('../../../../../i18n/de');
    case 'es-ES':
    case 'es':
      return import('../../../../../i18n/es');
    case 'et-EE':
    case 'et':
      return import('../../../../../i18n/et');
    case 'fi-FI':
    case 'fi':
      return import('../../../../../i18n/fi');
    case 'fr-FR':
    case 'fr':
      return import('../../../../../i18n/fr');
    case 'hu-HU':
    case 'hu':
      return import('../../../../../i18n/hu');
    case 'it-IT':
    case 'it':
      return import('../../../../../i18n/it');
    case 'ja-JP':
    case 'ja':
      return import('../../../../../i18n/ja');
    case 'ko-KR':
    case 'ko':
      return import('../../../../../i18n/ko');
    case 'nb-NB':
    case 'nb':
      return import('../../../../../i18n/nb');
    case 'nl-NL':
    case 'nl':
      return import('../../../../../i18n/nl');
    case 'pl-PL':
    case 'pl':
      return import('../../../../../i18n/pl');
    case 'pt-BR':
    case 'pt':
      return import('../../../../../i18n/pt_BR');
    case 'pt-PT':
      return import('../../../../../i18n/pt_PT');
    case 'ru-RU':
    case 'ru':
      return import('../../../../../i18n/ru');
    case 'sk-SK':
    case 'sk':
      return import('../../../../../i18n/sk');
    case 'sv-SE':
    case 'sv':
      return import('../../../../../i18n/sv');
    case 'tr-TR':
    case 'tr':
      return import('../../../../../i18n/tr');
    case 'th-TH':
    case 'th':
      return import('../../../../../i18n/th');
    case 'uk-UK':
    case 'uk':
      return import('../../../../../i18n/uk');
    case 'vi-VI':
    case 'vi':
      return import('../../../../../i18n/vi');
    case 'zh-TW':
    case 'zh-HK':
    case 'zh':
      return import('../../../../../i18n/zh_TW');
    case 'zh-ZH':
    case 'zh-CN':
      return import('../../../../../i18n/zh');
  }
  return Promise.resolve({
    default: {}
  });
}
var shouldLoadRemoteLocale = function shouldLoadRemoteLocale(locale) {
  return locale !== 'en';
};
export function useFetchMessagesByLocale(locale) {
  var _getCodesFromLocale = getCodesFromLocale(locale),
    language = _getCodesFromLocale.language,
    country = _getCodesFromLocale.country;
  var lastLocaleLoaded = useRef();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    messages = _useState2[0],
    setMessages = _useState2[1];
  var _useState3 = useState(!shouldLoadRemoteLocale(language)),
    _useState4 = _slicedToArray(_useState3, 2),
    isReady = _useState4[0],
    setIsReady = _useState4[1];
  var fireI18nFailedToLoad = useCreateFireAnalyticsFromTrigger(triggerI18nFailedToLoad);
  useEffect(function () {
    function startToFetchMessagesByLocale() {
      return _startToFetchMessagesByLocale.apply(this, arguments);
    }
    function _startToFetchMessagesByLocale() {
      _startToFetchMessagesByLocale = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var finalLocale, module, newMessages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!shouldLoadRemoteLocale(language) || locale === lastLocaleLoaded.current)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              finalLocale = country ? "".concat(language, "-").concat(country) : language;
              _context.next = 6;
              return fetchLanguageFile(finalLocale);
            case 6:
              module = _context.sent;
              newMessages = module.default || module;
              lastLocaleLoaded.current = locale;
              setMessages(newMessages);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              fireI18nFailedToLoad(locale);
            case 15:
              _context.prev = 15;
              setIsReady(true);
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 12, 15, 18]]);
      }));
      return _startToFetchMessagesByLocale.apply(this, arguments);
    }
    void startToFetchMessagesByLocale();
  }, [fireI18nFailedToLoad, locale, language, country]);
  return {
    messages: messages,
    isReady: isReady
  };
}